import React from 'react';
import { DesignSystemProvider } from '@bynder/design-system';
import { useDateFnsLocaleContext } from './Localization/DateFnsLocaleProvider';

export function DesignSystemProviderWithLocale({ children }: { children: React.ReactNode }) {
	const { locale } = useDateFnsLocaleContext();

	return (
		<DesignSystemProvider dateFnsLocale={locale} buttonVersion="legacy">
			{children}
		</DesignSystemProvider>
	);
}
